import EVENT_METADATA_TYPES from './event-metadata-types'
import EVENT_SUBTYPES from './event-subtypes'

export const EVENT_FILTER_ACTION_GROUPS = {
  ADDED: {
    name: 'Added',
    [EVENT_METADATA_TYPES.INGREDIENT]: {
      CREATE: {
        value: EVENT_SUBTYPES.CREATE,
        label: 'Create Ingredient',
      },
      CREATE_KEYWORD: {
        value: EVENT_SUBTYPES.CREATE_KEYWORD,
        label: 'Create Ingredient Keyword',
      },
      COMPONENT_DETAILS_CREATE: {
        value: EVENT_SUBTYPES.COMPONENT_DETAILS_CREATE,
        label: 'Create Ingredient Definite / Probable Component',
      },
      EXTRA_DETAILS_PHRASES_CREATE: {
        value: EVENT_SUBTYPES.EXTRA_DETAILS_PHRASES_CREATE,
        label: 'Create Negative / Pairing / Referencing Phrases',
      },
      EXTRA_DETAILS_INGREDIENTS_CREATE: {
        value: EVENT_SUBTYPES.EXTRA_DETAILS_INGREDIENTS_CREATE,
        label: 'Create Pairing / Referencing Ingredients',
      },
      OVERRIDES_DETAILS_CREATE: {
        value: EVENT_SUBTYPES.OVERRIDES_DETAILS_CREATE,
        label: 'Create Overrides Ingredient',
      },
      ALTERNATIVE_INGREDIENTS_DETAILS_CREATE: {
        value: EVENT_SUBTYPES.ALTERNATIVE_INGREDIENTS_DETAILS_CREATE,
        label: 'Create Alternative Ingredients based on Diet',
      },
    },
    [EVENT_METADATA_TYPES.DISH_TYPE]: {
      CREATE: {
        value: EVENT_SUBTYPES.CREATE,
        label: 'Create Dish Type',
      },
      ADDITIONAL_INGREDIENTS_DETAILS_CREATE: {
        value: EVENT_SUBTYPES.ADDITIONAL_INGREDIENTS_DETAILS_CREATE,
        label: 'Create Definite / Probable Ingredients',
      },
      ALTERNATIVE_INGREDIENTS_DETAILS_CREATE: {
        value: EVENT_SUBTYPES.ALTERNATIVE_INGREDIENTS_DETAILS_CREATE,
        label: 'Create Alternative Ingredients based on Dish Type',
      },
    },
    [EVENT_METADATA_TYPES.INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE]: {
      CREATE: {
        value: EVENT_SUBTYPES.CREATE,
        label: 'Create Common Negative Phrase',
      },
    },
    [EVENT_METADATA_TYPES.INGREDIENT_SPECIAL_CASE]: {
      CREATE: {
        value: EVENT_SUBTYPES.CREATE,
        label: 'Create Special Case Ingredient',
      },
    },
  },
  REMOVED: {
    name: 'Removed',
    [EVENT_METADATA_TYPES.INGREDIENT]: {
      DELETE: {
        value: EVENT_SUBTYPES.DELETE,
        label: 'Delete Ingredient',
      },
      DELETE_KEYWORD: {
        value: EVENT_SUBTYPES.DELETE_KEYWORD,
        label: 'Delete Ingredient Keyword',
      },
      COMPONENT_DETAILS_DELETE: {
        value: EVENT_SUBTYPES.COMPONENT_DETAILS_DELETE,
        label: 'Delete Ingredient Definite / Probable Component',
      },
      EXTRA_DETAILS_PHRASES_DELETE: {
        value: EVENT_SUBTYPES.EXTRA_DETAILS_PHRASES_DELETE,
        label: 'Delete Negative / Pairing / Referencing Phrases',
      },
      EXTRA_DETAILS_INGREDIENTS_DELETE: {
        value: EVENT_SUBTYPES.EXTRA_DETAILS_INGREDIENTS_DELETE,
        label: 'Delete Pairing / Referencing Ingredients',
      },
      OVERRIDES_DETAILS_DELETE: {
        value: EVENT_SUBTYPES.OVERRIDES_DETAILS_DELETE,
        label: 'Delete Overrides Ingredient',
      },
      ALTERNATIVE_INGREDIENTS_DETAILS_DELETE: {
        value: EVENT_SUBTYPES.ALTERNATIVE_INGREDIENTS_DETAILS_DELETE,
        label: 'Delete Alternative Ingredients based on Diet',
      },
    },
    [EVENT_METADATA_TYPES.DISH_TYPE]: {
      DELETE: {
        value: EVENT_SUBTYPES.DELETE,
        label: 'Delete Dish Type',
      },
      ADDITIONAL_INGREDIENTS_DETAILS_DELETE: {
        value: EVENT_SUBTYPES.ADDITIONAL_INGREDIENTS_DETAILS_DELETE,
        label: 'Delete Definite / Probable Ingredients',
      },
      ALTERNATIVE_INGREDIENTS_DETAILS_DELETE: {
        value: EVENT_SUBTYPES.ALTERNATIVE_INGREDIENTS_DETAILS_DELETE,
        label: 'Delete Alternative Ingredients based on Dish Type',
      },
    },

    [EVENT_METADATA_TYPES.INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE]: {
      DELETE: {
        value: EVENT_SUBTYPES.DELETE,
        label: 'Delete Common Negative Phrase',
      },
    },
    [EVENT_METADATA_TYPES.INGREDIENT_SPECIAL_CASE]: {
      DELETE: {
        value: EVENT_SUBTYPES.DELETE,
        label: 'Delete Special Case Ingredient',
      },
    },
  },
  UPDATED: {
    name: 'Updated',
    [EVENT_METADATA_TYPES.INGREDIENT_SPECIAL_CASE]: {
      UPDATE: {
        value: EVENT_SUBTYPES.UPDATE,
        label: 'Update Special Case Ingredient',
      },
    },
  },
  MOVED: {
    name: 'Moved',
    [EVENT_METADATA_TYPES.INGREDIENT]: {
      SENT_KEYWORD_TO_DICTIONARY: {
        value: EVENT_SUBTYPES.SENT_KEYWORD_TO_DICTIONARY,
        label: 'Sent Keyword to Dictionary',
      },
      SENT_KEYWORD_TO_INGREDIENT: {
        value: EVENT_SUBTYPES.SENT_KEYWORD_TO_INGREDIENT,
        label: 'Sent Keyword to Ingredient',
      },
    },
    [EVENT_METADATA_TYPES.DICTIONARY_WORD]: {
      SENT_KEYWORD_TO_INGREDIENT: {
        value: EVENT_SUBTYPES.SENT_KEYWORD_TO_DICTIONARY,
        label: 'Sent Keyword to Ingredient',
      },
    },
  },
  RECEIVED: {
    name: 'Received',
    [EVENT_METADATA_TYPES.INGREDIENT]: {
      RECEIVED_KEYWORD_FROM_DICTIONARY: {
        value: EVENT_SUBTYPES.RECEIVED_KEYWORD_FROM_DICTIONARY,
        label: 'Received Keyword from Dictionary',
      },
      RECEIVED_KEYWORD_FROM_INGREDIENT: {
        value: EVENT_SUBTYPES.RECEIVED_KEYWORD_FROM_INGREDIENT,
        label: 'Received Keyword from Ingredient',
      },
    },
    [EVENT_METADATA_TYPES.DICTIONARY_WORD]: {
      RECEIVED_KEYWORD_FROM_INGREDIENT: {
        value: EVENT_SUBTYPES.RECEIVED_KEYWORD_FROM_DICTIONARY,
        label: 'Received Keyword from Ingredient',
      },
    },
  },
}

export default EVENT_FILTER_ACTION_GROUPS
